import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translationEN } from "./translationEN";
import { translationRU } from "./translationRU";
import { translationES } from "./translationES";
import { translationPT } from "./translationPT";
import { translationTR } from "./translationTR";

const resources = {
  EN: { translation: translationEN },
  RU: { translation: translationRU },
  ES: { translation: translationES },
  PT: { translation: translationPT },
  TR: { translation: translationTR },
};

// 🔹 ограничим возможные языки ключами resources
type Lang = keyof typeof resources;

// берём первые 2 буквы и приводим к типу Lang
const rawLang = navigator.language.split("-")[0].toUpperCase(); // например "EN"
const browserLang: Lang = (Object.keys(resources).includes(rawLang) ? rawLang : "EN") as Lang;

i18n.use(initReactI18next).init({
  resources,
  lng: browserLang,
  fallbackLng: "EN",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
